import { useState } from 'react';
import type { HITLRendererProps } from '../HITLRenderer';
import { hitlStyles, cn } from './styles';

export const MultipleChoiceRenderer: React.FC<HITLRendererProps> = ({
  response,
  onSubmit,
  isSubmitting,
  compact,
}) => {
  const [selected, setSelected] = useState<Set<string>>(new Set());

  const toggleOption = (optionId: string) => {
    setSelected(prev => {
      const next = new Set(prev);
      if (next.has(optionId)) {
        next.delete(optionId);
      } else {
        next.add(optionId);
      }
      return next;
    });
  };

  const handleSubmit = () => {
    if (selected.size > 0) {
      onSubmit(Array.from(selected));
    }
  };

  return (
    <div className={compact ? hitlStyles.containerCompact : hitlStyles.container}>
      {response.message && (
        <p className={hitlStyles.message}>{response.message}</p>
      )}
      
      {response.context && (
        <p className={hitlStyles.context}>{response.context}</p>
      )}

      <div className="space-y-2 mb-3">
        {response.options?.map((option) => (
          <button
            key={option.id}
            onClick={() => toggleOption(option.id)}
            disabled={isSubmitting}
            className={cn(
              hitlStyles.optionButton,
              selected.has(option.id)
                ? hitlStyles.optionButtonSelected
                : hitlStyles.optionButtonDefault
            )}
          >
            <span className="inline-block w-4 h-4 mr-2 border rounded align-middle">
              {selected.has(option.id) && (
                <svg className="w-4 h-4 text-domino-aubergine" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              )}
            </span>
            {option.label}
          </button>
        ))}
      </div>

      <button
        onClick={handleSubmit}
        disabled={selected.size === 0 || isSubmitting}
        className={cn(hitlStyles.actionButton, hitlStyles.actionButtonPrimary, 'w-full')}
      >
        {isSubmitting ? (
          <span className="flex items-center justify-center gap-2">
            <span className={hitlStyles.spinner} />
            Processing...
          </span>
        ) : (
          `Continue (${selected.size} selected)`
        )}
      </button>
    </div>
  );
};
